/**
 * Passkey post-login offer ID strings.
 */
export const PASSKEY_ENROLL_OFFER_ID = 'passkey-no-mfa-code';
export const PASSKEY_ENROLL_MFA_OFFER_ID = 'passkey-with-mfa-code';
